/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

import { ModuleRegistry, ClientSideRowModelModule, RowStyleModule, ValidationModule, TooltipModule, CellStyleModule } from 'ag-grid-community';

ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  RowStyleModule,
  CellStyleModule,
  ValidationModule,
  TooltipModule
]);

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
